import { render, staticRenderFns } from "./deletePersonnel.vue?vue&type=template&id=45ba7cba&"
import script from "./deletePersonnel.vue?vue&type=script&lang=js&"
export * from "./deletePersonnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports